import axios from "axios";
import store from "../store";
import router from "../router";
import { sha256 } from "js-sha256";
import Vue from "vue";
import { Toast } from "vant";
Vue.use(Toast);
// 创建axios实例
//console.log(process.env)
const service = axios.create({
    baseURL: process.env.VUE_APP_URL_THREE, // api 的 VUE_APP_URL
    timeout: 50000, // 请求超时时间(因为需要调试后台,所以设置得比较大)
});
axios.defaults.headers["Content-Type"] = "application/json"; //此处是增加的代码，设置请求头的类型

// request拦截器,在请求之前做一些处理
service.interceptors.request.use(
    (config) => {
        let time = Date.now();
        //config.headers["Authorization"] = "eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJleHAiOjE2Mzg1ODUwMjMsImlhdCI6MTYyMzAzMzAyMywiaXNzIjoiZ3d0IFNlcnZlciIsImJlYW5JZCI6IjI4Njk4NTIwNjI5MjM4MDg3NjgiLCJyb2xlQ29kZSI6Imd1ZXN0IiwiY2hhbm5lbCI6IjEyMyJ9.AmWQw2MxWHOTiWfQY0iQtOXgzwCAnZRBT0p3QxYUbjjDwL73G7nrLv1f-H2FKok0om9alfa5GoOoQRrcjcYI7kful_bqcnL8V6t_1YM-iGMGV74GgEEUWF7NkS_VeGN803a3lzuU2dYk0GNPKeuhfN18i8jloaUt7vOFnyUw5jtp4AcSq59Uw326P5UPY20SdKRGqKyjVrl50kyigUIbANxymNScasItxVDp-IS859Wu1hdk14OS7mGvwa9mhabcqDWqpwadHJslTXIG435Oz9rjGf5lxkGkkjzi3UiyA5Btt05S-lx-u2Y5pXSsNuhxLH-cVUIq2iNtZpm5oePMaXgGUiBcca4";
        //config.headers["SourceApp"] = "ORA";
        //config.headers["SourceType"] = "IOS";
        config.headers["appId"] = "1448919637847162882";
        config.headers["appSecret"] = "ln3ndnkl31n4cvgh12bb123bkb4bkj12";
        config.headers["TimeStamp"] = time;
        
        return config;
    },
    (error) => {

        Promise.reject(error);

    }
);

// response 拦截器,数据返回后进行一些处理
service.interceptors.response.use(
    (response) => {
        /**
         * code为非20000是抛错 可结合自己业务进行修改
         */
        const res = response.data;
        if (res.code === "000000") {
            return res;

        }
        else {
            Promise.reject(res.description);
            Toast.fail(res.description)
            return res
        }
    },
    (error) => {
        Promise.reject("网络异常");
    }
);
export default service;
